import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BookingScheduleInterface } from "../../Booking-Form/typings/booking.types";
import { isVisitConsentDataAvailable } from "./visitor-bookings-consent.logic";

type P = {
  visit: BookingScheduleInterface;
};

export function VisitorBookingsConsentCell({ visit }: Readonly<P>) {
  const { t } = useTranslation();

  if (!isVisitConsentDataAvailable(visit)) {
    return (
      <Typography variant="body2" color="text.secondary">
        {t("_visitorBookings_consentNotInSchedule")}
      </Typography>
    );
  }

  const documents = visit.visitConsent?.documents ?? [];
  const consentedDocumentsCount = documents.filter(doc => doc.consented).length;
  const totalDocumentsCount = documents.length;

  let signatureLabel: string;
  if (visit.visitConsent?.signatureStored === true) {
    signatureLabel = t("_visitorBookings_consentSignatureSigned");
  } else if (visit.visitConsent?.signatureStored === false) {
    signatureLabel = t("_visitorBookings_consentSignatureNotSigned");
  } else {
    signatureLabel = t("_visitorBookings_consentSignatureUnknown");
  }

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", gap: 0.5, maxWidth: 320 }}
      data-testid={`visitor-booking-consent-${visit.id}`}
    >
      <Typography variant="caption" component="div">
        {t("_visitorBookings_consentDocumentsSummary", {
          consentedCount: consentedDocumentsCount,
          totalCount: totalDocumentsCount
        })}
      </Typography>
      <Typography variant="caption" component="div">
        {t("_visitorBookings_consentSignature")}: {signatureLabel}
      </Typography>
    </Box>
  );
}
